module.exports = __webpack_public_path__ + "img/mb-advantage-2.7597a812.png";